export enum FolderStatus {
  Closed = 'Clos',
  Waiting = 'En attente',
  InProgress = 'En cours',
  ToGuide = 'À orienter',
  notValidated = 'Non validé',
}

export const labelsByFolderStatus: Map<FolderStatus, string> = new Map<FolderStatus, string>(
  Object.keys(FolderStatus).map((x: string) => [x, FolderStatus[x]] as [FolderStatus, string]),
);
